@import (reference) "../../../styles/colors.less";

.Autosave {
  font-size: 13px;
  color: @mdb-color-lighten-3;
}
